import { useAppDispatch } from "./useReduxHooks";
import { userApi, accountsApi, campaignsApi } from "../api";
import { resetAuth } from "../features/authSlice";
import { useCallback } from "react";

export const useLogout = () => {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    localStorage.clear();
    dispatch(userApi.util.resetApiState());
    dispatch(accountsApi.util.resetApiState());
    dispatch(campaignsApi.util.resetApiState());
    dispatch(resetAuth());
  }, [dispatch]);
};
